
import {defineComponent} from 'vue';
import clickOutsideDirective from '../../../directives/click-outside';

export default defineComponent({
  name: 'oxd-dropdown-menu',

  data() {
    return {
      isActive: false,
    };
  },

  emits: ['dropdown:opened', 'dropdown:closed'],

  directives: {
    'click-outside': clickOutsideDirective,
  },

  methods: {
    openSubmenu() {
      this.isActive = true;
      this.$emit('dropdown:opened');
    },
    closeSubMenu() {
      if (this.isActive) {
        this.isActive = false;
        this.$emit('dropdown:closed');
      }
    },
  },
});
